<template>
  <!--<div v-if="historyData" :class="componentClassName">-->
  <div :class="componentClassName">
    <a-page-heading>発着信履歴 </a-page-heading>
    <m-section>
      <m-action-card class="t-history-detail__card" title="発着信履歴詳細" icon="phone-call-history">
        <div class="t-history-detail__voice-spaceline"></div>
        <div class="t-history-detail__card-set">
          <m-action-card class="t-history-detail__info-card">
            <a-summary-item-header text="相手先情報">
              <a-button
                v-if="isExistsContactData"
                :inline="true"
                variant="round"
                color="grey"
                size="small"
                icon="edit"
                label="編集"
                @click="handleEditCallerInformation"
              />
            </a-summary-item-header>
            <!-- <m-data-list :data="historyData.contact" align-right /> -->
            <m-data-list>
              <a-data-list-item align="right" label="氏名">{{ contact.name }}</a-data-list-item>
              <a-data-list-item align="right" label="電話番号">{{ contact.partner_number }}</a-data-list-item>
              <a-data-list-item align="right" label="メールアドレス">{{ contact.email }}</a-data-list-item>
              <a-data-list-item align="right" label="会社名">{{ contact.company_name }}</a-data-list-item>
              <a-data-list-item align="right" label="住所">{{ contact.street_address }}</a-data-list-item>
            </m-data-list>
            <a-summary-item-header text="発着信内容" />
            <!-- <m-data-list :data="historyData.content" align-right @click:action="handleActionButtonClick" /> -->
            <m-data-list>
              <a-data-list-item align="right" label="応対者">{{ agent_name }}</a-data-list-item>
              <!--<a-data-list-item align="right" label="タグ">{{ historyData.contenttag }}</a-data-list-item>-->
              <a-data-list-item align="right" label="実通話時間">{{ talk_time }}</a-data-list-item>
              <a-data-list-item align="right" label="課金時間">{{ billing_time }}</a-data-list-item>
              <a-data-list-item align="right" label="メモ" vertical-align="top" paragraph>
                <p style="white-space: pre-wrap; word-wrap: break-word">{{ memo }}</p>
                <!-- <a-text>{{ memo }}</a-text> -->
                <!-- <textarea class="a-text-field__input" v-model="memo" placeholder="" maxlength="100" cols="52"></textarea> -->
                <!-- <m-button-container variant="horizontal" class="t-history-detail__action-button">
              <a-button
                :inline="true"
                variant="round"
                color="grey"
                size="small"
                icon="edit"
                label="保存"
                @click="handleEditMemoClick"
              />
            </m-button-container> -->
                <m-button-container v-show="memoEditFlag" variant="horizontal" class="t-history-detail__action-button">
                  <a-button
                    id="edit"
                    :inline="true"
                    variant="round"
                    color="grey"
                    size="small"
                    icon="edit"
                    label="編集"
                    @click="
                      memoDialogVisible = true;
                      dialog_memo = memo;
                    "
                  />
                </m-button-container>
              </a-data-list-item>
            </m-data-list>
            <div v-if="!recordingUrl || !isShowTranscript">
              <a-summary-item-header text="通話データ">
                <a-button
                  v-if="canDeleteRecordings"
                  v-show="recordingUrl"
                  id="deleteBtn"
                  :inline="true"
                  variant="round"
                  color="grey"
                  size="small"
                  icon="trash"
                  label="削除"
                  @click="confirmDeleteRecording"
                />
              </a-summary-item-header>
              <m-data-list>
                <a-data-list-item v-show="!recordingUrl" align="right" label="音声・テキスト"
                  >削除しました</a-data-list-item
                >
                <a-data-list-item
                  v-if="showPlayButton"
                  v-show="recordingUrl"
                  align="right"
                  label="音声"
                  vertical-align="top"
                  paragraph
                >
                  <m-audio-player v-show="showPlayer" :audio-url="audioURL" :autoplay="true" />
                  <audio v-show="false" controls :src="audioURL">Your browser does not support the audio tag.</audio>
                  <m-button-container variant="horizontal" class="t-history-detail__action-button">
                    <a-button
                      v-if="!(selectedCompanyID === point && authInfo === 'operator')"
                      v-show="!showPlayer && !loading"
                      id="play"
                      :inline="true"
                      variant="round"
                      color="grey"
                      size="small"
                      icon="play"
                      label="再生"
                      @click="handlePlayRecordingClick"
                    />
                    <a-button
                      v-if="downloadable && companyID !== point && authInfo !== 'operator'"
                      v-show="showPlayer"
                      id="download"
                      :inline="true"
                      variant="round"
                      color="grey"
                      size="small"
                      icon="download"
                      label="ダウンロード"
                      @click="handleDownloadRecordingClick"
                    />
                    <a-loading v-if="loading"></a-loading>
                  </m-button-container>
                </a-data-list-item>
                <a-data-list-item
                  v-if="companyID !== point"
                  v-show="
                    canVoiceToText &&
                    !trialCompany &&
                    !isShowTranscript &&
                    recordingUrl &&
                    status !== '不在着信' &&
                    !isVdxNum
                  "
                  align="right"
                  label="テキスト"
                >
                  <m-button-container variant="horizontal" class="t-history-detail__action-button">
                    <a-button
                      v-show="voiceToTextStatus !== 'processing'"
                      id="doVoiceToTextBtn"
                      variant="round"
                      size="middle"
                      label="通話録音をテキスト化"
                      color="primary"
                      :inline="true"
                      @click="confirmDoVoiceToText"
                    />
                    <a-button
                      v-show="voiceToTextStatus === 'processing'"
                      id="processingVoiceToTextBtn"
                      variant="round"
                      size="middle"
                      label="テキスト化中"
                      color="primary"
                      :inline="true"
                      @click="confirmDoVoiceToText"
                    />
                  </m-button-container>
                </a-data-list-item>
              </m-data-list>
            </div>
            <div class="t-history-detail__buttons">
              <m-button-container>
                <a-button id="back" variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>
              </m-button-container>
            </div>
            <!--<div class="t-history-detail__footer">
          <a-button
            variant="round"
            color="primary"
            icon="phone-outgoing-call"
            icon-color="white"
            label="発信"
            :inline="true"
            @click="handlePhoneCallClick"
          />
        </div>-->
          </m-action-card>
          <m-data-card v-show="recordingUrl && isShowTranscript" class="t-history-detail__data-card" title="通話データ">
            <template #data>
              <a-button
                v-if="canDeleteRecordings"
                id="t-history-detail__voice-delete"
                :inline="true"
                variant="round"
                color="white"
                size="small"
                icon="trash"
                label="削除"
                @click="confirmDeleteRecording"
              />
            </template>
            <div class="t-history-detail__voice">
              <div class="t-history-detail__voice-header">
                <h5>音声</h5>
                <a-button
                  v-if="downloadable && companyID !== point && authInfo !== 'operator'"
                  v-show="showPlayer"
                  id="t-history-detail__voice-download"
                  :inline="true"
                  variant="round"
                  color="white"
                  size="small"
                  icon="download"
                  label="ダウンロード"
                  @click="handleDownloadRecordingClick"
                />
              </div>
              <div class="t-history-detail__voice-to-text-container">
                <m-recording-audio-player
                  v-if="playRecordingModalVisible"
                  v-show="!loading"
                  :audio-url="audioURL"
                  :autoplay="true"
                  :start-time="start_time"
                  :is-middle-play="isMiddlePlay"
                />
                <m-button-container variant="horizontal" class="t-history-detail__action-button">
                  <a-button
                    v-if="!playRecordingModalVisible && !(selectedCompanyID === point && authInfo === 'operator')"
                    id="t-history-detail__voice-play"
                    :inline="true"
                    variant="round"
                    color="white"
                    size="medium"
                    icon="play"
                    label="再生"
                    @click="doStartRecording"
                  />
                  <a-loading v-if="loading"></a-loading>
                </m-button-container>
              </div>
              <audio v-show="false" controls :src="audioURL">Your browser does not support the audio tag.</audio>
            </div>
            <div class="t-history-detail__voice-underline"></div>
            <div class="t-history-detail__voice">
              <h5>
                テキスト
                <template v-if="textEditMode == false">
                  <!-- #5341 テキスト化結果だけ削除機能を今後また使うかもしれないのでコメントアウト対応する -->
                  <!-- <a-button
                    v-if="canDeleteRecordings"
                    id="t-history-detail__voice-to-text-delete"
                    :inline="true"
                    variant="round"
                    color="white"
                    size="small"
                    icon="trash"
                    label="削除"
                    @click="confirmDeleteText"
                  /> -->
                  <a-button
                    v-if="canEditVoiceToText"
                    id="t-history-detail__voice-to-text-edit-btn"
                    :inline="true"
                    variant="round"
                    :color="isTextFromGCS === true ? 'grey' : 'white'"
                    size="small"
                    icon="edit"
                    label="編集"
                    @click="changeTextEditMode"
                  />
                  <a-button
                    v-if="companyID !== point && authInfo !== 'operator'"
                    id="t-history-detail__voice-to-text-download"
                    :inline="true"
                    variant="round"
                    color="white"
                    size="small"
                    icon="download"
                    label="ダウンロード"
                    @click="downloadCSV"
                  />
                  <a-find-in-page-search
                    v-model="searchText"
                    class="fixed top-6 right-6"
                    @update:modelValue="emitEvent"
                  ></a-find-in-page-search>
                </template>
                <template v-else>
                  <a-button
                    v-if="canEditVoiceToText"
                    id="t-history-detail__voice-to-text-cancel-btn"
                    :inline="true"
                    variant="round"
                    color="white"
                    size="small"
                    label="キャンセル"
                    @click="cancelTextEditMode"
                  />
                  <a-button
                    v-if="canEditVoiceToText"
                    id="t-history-detail__voice-to-text-save-btn"
                    :inline="true"
                    variant="round"
                    color="white"
                    size="small"
                    label="保存"
                    @click="handleTextEdit"
                  />
                  <a-find-in-page-search
                    class="fixed top-6 right-6"
                    disabled="disabled"
                    @update:modelValue="emitEvent"
                  ></a-find-in-page-search>
                </template>
              </h5>
              <div v-if="textResultList.length == 0" v-show="isShowTranscript">
                <p class="t-history-detail__silent-message">{{ silentTextMessage }}</p>
              </div>
              <div
                v-if="textResultList.length > 0"
                v-show="isShowTranscript"
                id="t-history-detail__text-box"
                class="t-history-detail__box"
              >
                <div v-for="(textResult, idx) in textResultList" :key="idx" ref="textResultList">
                  <div
                    v-if="(textResult.channelTag === 2) | (voicemessageFlag === true)"
                    class="t-history-detail__user-1"
                  >
                    <template v-if="textEditMode == false">
                      <div class="t-history-detail__channel-2" @click="doStartRecordingInMiddle(textResult.startTime)">
                        <a-find-in-page-content v-model="searchText" :model-value="modelValue">
                          <p :id="`cardText2_idx${idx}`" class="t-history-detail__card-text-2">
                            {{ textResult.transcript }}
                          </p>
                        </a-find-in-page-content>
                      </div>
                      <div class="t-history-detail__user-time-2">
                        {{ time_convert(textResult.startTime) }}
                      </div>
                    </template>
                    <template v-else>
                      <textarea
                        :id="`editCardText2_idx${idx}`"
                        v-model="textResult.transcript"
                        class="t-history-detail__edit-card-text-2"
                        type="text"
                        wrap="soft"
                      />
                      <a-button
                        :id="`textTrash2Btn_idx${idx}`"
                        class="t-history-detail__text-trash-2"
                        :inline="true"
                        variant="round"
                        color="grey"
                        size="small"
                        icon="trash"
                        @click="doDeleteText(idx)"
                      />
                      <div class="t-history-detail__edit-user-time-2">
                        {{ time_convert(textResult.startTime) }}
                      </div>
                    </template>
                  </div>
                  <div v-if="textResult.channelTag === 1" class="t-history-detail__user-2">
                    <template v-if="textEditMode == false">
                      <div class="t-history-detail__user-time-1">
                        {{ time_convert(textResult.startTime) }}
                      </div>
                      <div
                        class="t-history-detail__channel-1"
                        @click="doStartRecordingInMiddle(Number(textResult.startTime))"
                      >
                        <a-find-in-page-content v-model="searchText" :model-value="modelValue">
                          <p :id="`cardText1_idx${idx}`" class="t-history-detail__card-text-1">
                            {{ textResult.transcript }}
                          </p>
                        </a-find-in-page-content>
                      </div>
                    </template>
                    <template v-else>
                      <div>
                        <span class="t-history-detail__edit-user-time-1">{{ time_convert(textResult.startTime) }}</span>
                      </div>
                      <a-button
                        :id="`textTrash1Btn_idx${idx}`"
                        class="t-history-detail__text-trash-1"
                        :inline="true"
                        variant="round"
                        color="grey"
                        size="small"
                        icon="trash"
                        @click="doDeleteText(idx)"
                      />
                      <textarea
                        :id="`editCardText1_idx${idx}`"
                        ref="area"
                        v-model="textResult.transcript"
                        class="t-history-detail__edit-card-text-1"
                        type="text"
                        wrap="soft"
                      />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </m-data-card>
        </div>
      </m-action-card>
    </m-section>
  </div>
  <!-- Help modal -->
  <teleport to="body">
    <o-modal
      id="HistoryDetail_memoModal"
      v-model:visible="memoDialogVisible"
      v-bind="$props"
      z-index="2000"
      :close-on-click-modal="false"
    >
      <template #title> メモ編集 </template>
      <a-text-field v-model="dialog_memo" type="textarea" placeholder="メモ" />
      <template #footer>
        <a-button
          id="memo-save"
          variant="block"
          color="primary"
          label="保存"
          size="small"
          @click="handleEditMemoClick"
        />
        <a-button
          id="memo-calcel"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          @click="memoDialogVisible = false"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="HistoryDetail_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
      <span v-html="resultModalContent" />
      <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <template v-if="modalFlg === 'emptyVoice'">
          <a-button
            id="closeModalBtn"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="handleCloseModal"
          />
        </template>
        <!-- #5341 テキスト化結果だけ削除機能を今後また使うかもしれないのでコメントアウト対応する -->
        <!-- <template v-if="modalFlg === 'confirmDelete'">
          <a-button
            id="closeModalBtn"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCloseModal"
          />
          <a-button id="confirmBtn" variant="block" color="primary" label="はい" size="small" @click="deleteText" />
        </template> -->
        <template v-if="modalFlg === 'confirmDeleteRecording'">
          <a-button
            id="closeModalBtn"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCloseModal"
          />
          <a-button
            id="confirmBtn"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="deleteRecording"
          />
        </template>
        <template v-if="modalFlg === 'confirmDoVoiceToText'">
          <a-button
            id="closeModalBtn"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCloseModal"
          />
          <a-button id="confirmBtn" variant="block" color="primary" label="はい" size="small" @click="doVoiceToText" />
        </template>
        <template v-if="modalFlg === 'error'">
          <a-button id="ok" variant="block" color="primary" label="はい" size="small" @click="handleCloseModal" />
        </template>
        <template
          v-if="
            modalFlg === 'saveMemoSuccess' ||
            modalFlg === 'notifyTrialUserCanNotUseThisFunction' ||
            modalFlg === 'requestDoVoiceToTextSetting' ||
            modalFlg === 'invalidCharactor'
          "
        >
          <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="HistoryDetail_helpModal"
      v-model:visible="helpDialogVisible"
      class="o-modal-help-dialog"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCloseHelpDialog"
    >
      <template #title>{{ currentHelpMessageTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
      <span v-html="currentHelpMessageText" />
        <!-- eslint-enable -->
      </a-text>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MDataCard from '@/components/molecules/data-card';
import ASummaryItemHeader from '@/components/atoms/summary-item-header';
import AButton from '@/components/atoms/button';
import MDataList from '@/components/molecules/data-list';
import ADataListItem from '@/components/atoms/data-list-item';
import MButtonContainer from '@/components/molecules/button-container';
import MRecordingAudioPlayer from '@/components/molecules/recording-audio-player';
import AText from '@/components/atoms/text';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';
import AFindInPageContent from '@/components/atoms/find-in-page-content';
import AFindInPageSearch from '@/components/atoms/find-in-page-search';
import { PERMISSIONS_FRONTEND } from '@/libs/constants';

import { utils } from '@/common/utils.js';
import dayjs from 'dayjs';
import { DEFAULT_TIMEZONE } from '@/libs/constants';

export default {
  name: 't-history-detail',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    MDataCard,
    ASummaryItemHeader,
    AButton,
    MDataList,
    ADataListItem,
    MButtonContainer,
    MRecordingAudioPlayer,
    AText,
    AFindInPageContent,
    AFindInPageSearch,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    //historyData: {
    //  type: Object,
    //  default: null,
    //},
    handleEditContact: {
      type: Function,
      default: () => {},
    },
    handleActionButtonClick: {
      type: Function,
      default: () => {},
    },
    //handleEditMemoClick: {
    //  type: Function,
    //  default: () => {},
    //},
    handleEditRecordingClick: {
      type: Function,
      default: () => {},
    },
    // handleDownloadRecordingClick: {
    //   type: Function,
    //   default: () => {},
    // },
    //handleCancelClick: {
    //  type: Function,
    //  default: () => {},
    //},
    handlePhoneCallClick: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      contact: {
        name: '',
        partner_number: '',
        email: '',
        company_name: '',
        street_address: '',
      },
      CallSid: '',
      agent_name: '',
      talk_time: '',
      billing_time: '',
      start_dt: '',
      memo: '',
      dialog_memo: '',
      selectedCompanyID: '',
      //companyID: '',
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      showPlayButton: false,
      helpDialogVisible: false,
      currentHelpMessageTitle: '',
      currentHelpMessageText: '',
      recording_url: null,
      showPlayer: false,
      loading: false,
      memoDialogVisible: false,
      audioURL: '',
      // #2423
      memoEditFlag: true,
      authInfo: this.$store.state.user.authInfo,
      // 通話履歴に紐づいたSalesforceのケースID
      sfCaseId: null,
      results: { channelTag: '', resultEndTime: '', alternatives: { transcript: '' } },
      showError: false,
      errorMessage: '',
      recording: null,
      defaultErrorMessage: `Something went wrong, please check the system's log for detail.`,
      timeout: [],
      isShowTranscript: false,
      time: '',
      modalFlg: '',
      textFlg: false,
      voiceToTextMode: false,
      voiceToTextOn: false,
      playRecordingModalVisible: false,
      selectedRow: {},
      audioURLs: [],
      start_time: 0,
      mediaData: null,
      recordingCbx: {},
      recordingUrl: null,
      voiceToTextStatus: null,
      status: this.$route.query.status,
      isVdxNum: true,
      modelValue: null,
      textEditMode: false,
      voicemessageFlag: false,
      textResultList: [],
      backupTextResultList: [],
      point: POINT,
      isExistsContactData: false, // 連絡先存在フラグ
      trialCompany: false,
      isMiddlePlay: false,
      silentTextMessage: messageContent.silentTextMessage,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-history-detail');
      return `${baseClassName} ${this.class}`.trim();
    },
    playable() {
      // Max duration that playable 60 minutes
      const maxDuration = 60 * 60;
      const talk_time = this.talk_time;
      const times = talk_time.match(/\d+/g);
      const duration = parseInt(times[0]) * 60 + parseInt(times[1]);
      return duration <= maxDuration;
    },
    downloadable() {
      // #2705
      if (this.authInfo === 'operator') {
        return false;
      }
      return this.companyID !== POINT;
    },
    canVoiceToText() {
      return this.voiceToTextOn && this.companyID !== POINT;
    },
    canDeleteRecordings() {
      return this.companyID !== POINT && (this.authInfo === 'supervisor' || this.authInfo === 'manager');
    },
    canEditVoiceToText() {
      return this.companyID !== POINT;
    },
  },
  async created() {
    this.CallSid = this.$route.query.CallSid;
    const formDataTmp = {
      callSid: this.CallSid,
    };
    await this.getCallLogDetail(formDataTmp);

    if (this.contact.partner_number) {
      await this.fetchContactDataHandler(this.contact.partner_number);
    }
    await this.canShowPlayButtonCheck();

    this.checkVdxbNum(this.selectedCompanyID, this.agent_name);
    this.getFlags();
    this.getText();

    // For Trial
    if (utils.chkTrialCompanyID(this.companyID)) {
      this.trialCompany = true;
    }
  },
  mounted() {
    // #2423
    if (PERMISSIONS_FRONTEND['HistoryDetail']) {
      if (!PERMISSIONS_FRONTEND['HistoryDetail'][this.authInfo]) {
        this.$router.push({ path: '/permission-denied' });
        return;
      }
    }

    // #2423
    if ((this.authInfo === 'operator' || this.authInfo === 'soOperator') && this.companyID === POINT) {
      this.memoEditFlag = false;
    }
    window.scrollTo(0, 0);
  },
  methods: {
    resize() {
      this.height = 'auto';
      this.$nextTick(() => {
        this.height = this.$refs.area.scrollHeight + 'px';
      });
    },
    getCallLogDetail: async function (formDataTmp) {
      await this.postRequest('/callLogClient/getCallLogDetail', formDataTmp)
        .then(e => {
          if (e.status) {
            if (!e.data || !e.data.length) {
              console.log('no permission');
              this.$router.push({ path: '/permission-denied' });
              return;
            }
            this.agent_name = this.$route.query.agent_name;
            this.talk_time = e.data[0].dispTime;
            this.start_dt = e.data[0].start_dt;
            this.billing_time = e.data[0].minuites + '分';
            this.contact.partner_number = this.formatPhoneNumberDisplay(e.data[0].partner_number);
            this.selectedCompanyID = e.data[0].companyID;
            this.memo = e.data[0].memo;
            this.recordingUrl = e.data[0].recordingUrl;
            this.voiceToTextStatus = e.data[0].voiceToTextStatus;
            if (
              !this.voiceToTextStatus ||
              this.voiceToTextStatus === 'textDeleted' ||
              this.voiceToTextStatus === 'textFailed' ||
              this.voiceToTextStatus === 'processing'
            ) {
              this.isShowTranscript = false;
            } else {
              this.isShowTranscript = true;
            }
          } else {
            this.showErrorModal(messageContent.fetchDataFailed('発着信履歴詳細'));
          }
        })
        .catch(er => {
          this.showErrorModal(messageContent.fetchDataFailed('発着信履歴詳細'));
        });
    },
    canShowPlayButtonCheck() {
      // #2423
      if (this.selectedCompanyID === POINT) {
        this.showPlayButton = false;
        return;
      }
      const formData = {
        // #2423
        //companyID: this.$store.state.user.companyID,
        companyID: this.selectedCompanyID,
        userID: this.$store.state.user.userID,
        callSid: this.CallSid,
      };
      this.postRequest('/call-history/getrecordingdata', formData).then(e => {
        if (e.status) {
          // this.showPlayButton = e.hasRecordingUrl && this.playable;
          this.showPlayButton = !!e.hasRecordingUrl;
        }
      });
    },
    handleCancelClick() {
      const query = {
        type: this.$route.query.type,
        phonebook_name: this.$route.query.search_phonebook_name,
        agent_name: this.$route.query.search_agent_name,
        memo: this.$route.query.search_memo,
        start: this.$route.query.start,
        end: this.$route.query.end,
        page: this.$route.query.page,
        phone_number: this.$route.query.search_phone_number,
      };
      const params = { filter: this.$route.params.filter };
      if (this.companyID === POINT) {
        this.$router.push({ name: 'HistoryList', query: { companyID: this.selectedCompanyID, ...query }, params });
      } else {
        this.$router.push({ name: 'HistoryList', query, params });
      }
    },
    fetchContactDataHandler: async function (contactID) {
      if (this.companyID === POINT) {
        await this.postRequest('/contactlist/getcontactdata', {
          contactID: contactID,
          companyID: this.selectedCompanyID,
        })
          .then(e => {
            if (e.session) {
              this.isExistsContactData = e.data && ['supervisor', 'manager'].includes(this.authInfo) ? true : false;
              this.contact.name = e.data.view_name;
              this.contact.partner_number = e.data.key;
              this.contact.email = e.data.mail;
              this.contact.company_name = e.data.companyName;
              this.contact.street_address = e.data.address;
              //e.data.memo
            } else {
              window.location.href = '/login';
            }
          })
          .catch(err => {
            //console.log(err);
            //this.showErrorModal('電話帳検索中にエラーが発生しました。時間を空けて再度実行してください。');
          });
      } else {
        this.postRequest('/contactlist/getcontactdata', { contactID: contactID, companyID: this.companyID })
          .then(e => {
            if (e.session) {
              this.isExistsContactData = e.data ? true : false;
              this.contact.name = e.data.view_name;
              this.contact.partner_number = e.data.key;
              this.contact.email = e.data.mail;
              this.contact.company_name = e.data.companyName;
              this.contact.street_address = e.data.address;
              //e.data.memo
            } else {
              window.location.href = '/login';
            }
          })
          .catch(err => {
            //console.log(err);
            //this.showErrorModal('電話帳検索中にエラーが発生しました。時間を空けて再度実行してください。');
          });
      }
    },
    formatPhoneNumberDisplay(pn) {
      return String(pn).replace('+81', '0');
    },
    handleEditMemoClick() {
      if (!this.hasSpecialCharacterInString(this.dialog_memo)) {
        const lengthCheck = this.memoLengthCheck(this.dialog_memo);
        if (!lengthCheck.status) {
          this.showErrorModal(lengthCheck.message);
          return;
        }

        // 先頭に改行コードがあれば消去する
        while (this.dialog_memo.match(/^\n/)) {
          this.dialog_memo = this.dialog_memo.replace(/^\n/, '');
        }

        this.changed_dialog_memo = this.dialog_memo.replace(/\n/g, '%%n%%');

        this.postRequest('/callLogClient/setmemo', {
          CallSid: this.CallSid,
          memo: this.changed_dialog_memo,
          selectedCompanyID: this.selectedCompanyID,
        })
          .then(e => {
            if (e.status) {
              //保存完了
              this.modalFlg = 'saveMemoSuccess';
              this.showInfoModal('メモを保存しました。');
              this.memoDialogVisible = false;
              this.memo = this.dialog_memo;
            }
          })
          .catch(err => {
            this.showErrorModal('メモの保存に失敗しました。');
            //console.log(err);
          });
      } else {
        this.showErrorModal(messageContent.hasSpecialCharacter);
      }
    },
    async getChunk(index, start) {
      //const res = await fetch(`${this.recording_url}?index=${index}&start=${start}`, {
      const tCompanyID = this.companyID === POINT ? this.selectedCompanyID : this.companyID;
      const res = await fetch(`${this.recording_url}?index=${index}&start=${start}&companyID=${tCompanyID}`, {
        method: 'GET',
      });
      if (res.status !== 200) throw messageContent.recordingNotFound;
      const isLastChunk = res.headers.get('Last-Chunk');
      const loadedSize = res.headers.get('Loaded-Size');
      const blob = await res.blob();
      return { blob, isLastChunk, loadedSize };
    },
    async playRecording() {
      try {
        this.loading = true;
        const segments = [];
        let loadedSize = 0;
        let [isLastChunk, i] = [null, 0];
        while (isLastChunk !== 'true') {
          const chunk = await this.getChunk(i, parseInt(loadedSize));
          const buffer = await chunk.blob.arrayBuffer();
          isLastChunk = chunk.isLastChunk;
          loadedSize = chunk.loadedSize;
          segments.push(buffer);
          i++;
        }
        this.loading = false;
        this.showPlayer = true;
        const length = segments.reduce((size, segment) => {
          return size + segment.byteLength;
        }, 0);
        const mediaData = new Uint8Array(length);
        let pos = 0;
        for (let i = 0; i < segments.length; ++i) {
          mediaData.set(new Uint8Array(segments[i]), pos);
          pos += segments[i].byteLength;
        }
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        const audioBlob = new Blob([mediaData.buffer], { type: 'audio/wav' });
        const url = window.URL.createObjectURL(audioBlob);
        const audioElem = document.querySelector('audio');
        audioElem.src = url;
        audioElem.onload = evt => {
          URL.revokeObjectURL(url);
        };
        this.audioURL = url;
      } catch (e) {
        this.loading = false;
        this.showErrorModal(messageContent.recordingNotFound);
      }
    },
    handlePlayRecordingClick() {
      const formData = {
        // #2423
        //companyID: this.$store.state.user.companyID,
        companyID: this.selectedCompanyID,
        userID: this.$store.state.user.userID,
        callSid: this.CallSid,
      };
      this.loading = true;
      this.postRequest('/call-history/getrecordingdata', formData)
        .then(e => {
          this.loading = false;
          if (e.status) {
            if (e.publicURL) {
              this.recording_url = e.publicURL;
              // this.showPlayer = true;
            } else {
              this.recording_url = `${location.origin}/Recordings/${e.urlPartial}`;
              // this.showPlayer = true;
            }
            // window.open(this.recording_url, "_blank");
            this.playRecording();
          }
        })
        .catch(() => {
          this.loading = false;
          this.showErrorModal(messageContent.requireTry('音声ファイルのダウンロード'));
        });
    },
    // eslint-disable-next-line require-await
    handleDownloadRecordingClick: async function () {
      const link = document.createElement('a');
      link.href = this.audioURL;
      link.download = `${this.start_dt.replace(/[^0-9]/g, '')}.wav`;
      link.click();
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleCloseHelpDialog() {
      this.helpDialogVisible = false;
    },
    handleRecordingHelpClick() {
      this.helpDialogVisible = true;
      this.currentHelpMessageTitle = messageContent.recordingHelpMessageTitle;
      this.currentHelpMessageText = messageContent.recordingHelpMessageContent;
    },
    // 音声テキスト化モードを確認する
    async getVoiceToTextFlg() {
      await this.postRequest('/callLogClient/search', { companyID: this.selectedCompanyID })
        .then(e => {
          if (e.status === 'success') {
            this.voiceToTextMode = e.data['voiceToTextFlg'];
            this.voiceToTextOn = e.data['voiceToTextOn'];
          }
        })
        .catch(error => {
          console.error(error);
          this.voiceToTextMode = false;
          this.modalFlg = 'error';
          this.showErrorModal(messageContent.callLogDownloadError);
        });
    },
    async getText() {
      const formData = {
        recordingUrl: this.recordingUrl,
        companyID: this.selectedCompanyID,
      };
      // Spannerから音声テキスト化結果を取得している
      await this.postRequest('/voicetotext/gettext', formData)
        .then(e => {
          if (e.status === 'success') {
            if (e.text_result_list) {
              this.textFlg = true;
              this.textResultList = e.text_result_list;
              this.backupTextResultList = JSON.parse(JSON.stringify(this.textResultList));
              this.authInfo = e.authInfo;
            } else {
              this.textFlg = false;
            }
          }
          // 音声テキスト化モードを確認し、表示/非表示を切り替えている
          this.getVoiceToTextFlg();
        })
        .catch(error => {
          console.error(error);
          this.voiceToTextMode = false;
          this.modalFlg = 'error';
          this.showErrorModal(messageContent.failDownloadText);
        });
    },
    time_convert(num) {
      const m = Math.floor(num / 60);
      const hours = ('0' + Math.floor(m / 60)).slice(-2);
      const seconds = ('0' + Math.floor(num % 60)).slice(-2);
      const minutes = ('0' + Math.floor(m % 60)).slice(-2);
      return `${hours}:${minutes}:${seconds}`;
    },
    // #5341 テキスト化結果だけ削除機能を今後また使うかもしれないのでコメントアウト対応する
    // confirmDeleteText() {
    //   this.modalFlg = 'confirmDelete';
    //   this.showModal(messageContent.confirmDelteText);
    // },
    showModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    downloadCSV() {
      let csv = 'ユーザー名,通話開始からの経過時間,通話内容\n';
      let u;
      this.textResultList.forEach((textResult, i) => {
        if (textResult.channelTag === 2) {
          u = 'オペレーター';
        } else {
          u = 'ユーザー';
        }
        if (textResult.transcript) {
          csv += `${u},${this.time_convert(textResult.startTime)},${textResult.transcript}\n`;
        }
      });
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, csv], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      const now = dayjs().tz(DEFAULT_TIMEZONE);
      const year = now.format('YYYY');
      const month = now.format('MM');
      const hour = now.format('HH');
      const min = now.format('mm');
      const sec = now.format('ss');
      const file_name = `CCCtext_${year}${month}${hour}${min}${sec}`;
      anchor.download = file_name + '.csv';
      anchor.href = url;
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    },
    doStartRecording() {
      this.isMiddlePlay = false;
      this.start_time = 0;
      this.playRecordingModalVisible = true;
      if (this.audioURLs[this.selectedRow.recordingUrl]) {
        this.playRecording();
        return;
      }
      const formData = {
        companyID: this.selectedCompanyID,
        userID: this.$store.state.user.userID,
        callSid: this.CallSid,
      };
      this.loading = true;
      this.postRequest('/call-history/getrecordingdata', formData)
        .then(e => {
          this.loading = false;
          if (e.status) {
            if (e.publicURL) {
              this.recording_url = e.publicURL;
            } else {
              this.recording_url = `${location.origin}/Recordings/${e.urlPartial}`;
            }
            this.playRecording();
          }
        })
        .catch(error => {
          console.error(error);
          this.modalFlg = 'error';
          this.loading = false;
          this.showErrorModal(messageContent.requireTry('音声ファイルのダウンロード'));
        });
    },
    doStartRecordingInMiddle(start_time) {
      this.isMiddlePlay = true;
      this.start_time = start_time;
      this.playRecordingModalVisible = true;
      if (this.audioURLs[this.selectedRow.recordingUrl]) {
        this.playRecording();
        return;
      }
      const formData = {
        companyID: this.selectedCompanyID,
        userID: this.$store.state.user.userID,
        callSid: this.CallSid,
      };
      this.loading = true;
      this.postRequest('/call-history/getrecordingdata', formData)
        .then(e => {
          this.loading = false;
          if (e.status) {
            if (e.publicURL) {
              this.recording_url = e.publicURL;
            } else {
              this.recording_url = `${location.origin}/Recordings/${e.urlPartial}`;
            }
            this.playRecording();
          }
        })
        .catch(error => {
          console.error(error);
          this.modalFlg = 'error';
          this.loading = false;
          this.showErrorModal(messageContent.requireTry('音声ファイルのダウンロード'));
        });
    },
    // #5341 テキスト化結果だけ削除機能を今後また使うかもしれないのでコメントアウト対応する
    // async deleteText() {
    //   const formData = {
    //     recordingUrl: this.recordingUrl,
    //     companyID: this.selectedCompanyID,
    //   };
    //   // SpannerとGCSから音声テキスト化結果を削除している
    //   await this.postRequest('/voicetotext/deletetext', formData)
    //     .then(res => {
    //       this.transcriptList = [];
    //       this.isShowTranscript = false;
    //       this.handleCloseModal();
    //     })
    //     .catch(error => {
    //       console.error(error);
    //       this.modalFlg = 'error';
    //       this.showErrorModal(messageContent.requireTry('音声テキスト化ファイル削除)'));
    //     });
    // },
    confirmDeleteRecording() {
      this.modalFlg = 'confirmDeleteRecording';
      this.showModal(messageContent.confirmDeleteRecording);
    },
    deleteRecording() {
      this.recordingCbx[this.CallSid] = true;
      // GCSから通録と音声テキスト化結果、Spannerから音声テキスト化を削除している
      this.postRequest('/callLogClient/deleteRecording', {
        CallSids: this.recordingCbx,
        companyID: this.selectedCompanyID,
      })
        .then(res => {
          if (res.status === 'success') {
            this.recordingUrl = null;
            this.handleCloseModal();
          } else {
            this.modalFlg = 'error';
            this.showErrorModal(messageContent.requireTry('通話録音の削除'));
          }
        })
        .catch(err => {
          console.log(err);
          this.modalFlg = 'error';
          this.showErrorModal(messageContent.requireTry('通話録音の削除'));
        });
    },
    confirmDoVoiceToText() {
      if (this.voiceToTextOn) {
        this.modalFlg = 'confirmDoVoiceToText';
        this.showModal(messageContent.confirmDoVoiceToText);
      } else if (this.trialCompany) {
        this.modalFlg = 'notifyTrialUserCanNotUseThisFunction';
        this.showInfoModal(messageContent.notifyTrialUserCanNotUseThisFunction());
      } else {
        this.modalFlg = 'requestDoVoiceToTextSetting';
        this.showInfoModal(messageContent.requestDoVoiceToTextSetting);
      }
    },
    doVoiceToText() {
      this.voiceToTextStatus = 'processing';
      const formData = {
        recordingUrl: this.recordingUrl,
        companyID: this.selectedCompanyID,
        callSid: this.CallSid,
      };
      // 通録ファイルをGCSにアップロードしている、その結果、音声テキスト化される
      this.postRequest('/voicetotext/createWavFile', formData);
      this.handleCloseModal();
    },
    handleEditCallerInformation() {
      this.$router.push({
        path: '/contactlist/edit',
        query: {
          contactID: this.contact.partner_number,
          companyID: this.selectedCompanyID,
          fromHistoryDetails: true,
          CallSid: this.CallSid,
          search_phonebook_name: this.$route.query.search_phonebook_name,
          search_agent_name: this.$route.query.search_agent_name,
          search_memo: this.$route.query.search_memo,
          start: this.$route.query.start,
          end: this.$route.query.end,
          type: this.$route.query.type,
          page: this.$route.query.page,
          search_phone_number: this.$route.query.search_phone_number,
          status: this.$route.query.status,
          agent_name: this.$route.query.agent_name,
        },
      });
    },
    async checkVdxbNum(companyId, telNum) {
      const formData = {
        companyId: companyId,
        telNum: telNum,
      };
      await this.postRequest('/voicetotext/checkVdxbNum', formData).then(res => {
        this.isVdxNum = res.result;
      });
    },
    emitEvent(modelValue) {
      this.modelValue = modelValue;
    },
    changeTextEditMode() {
      // 編集ができるように、入力フォームに切り替わる
      this.textEditMode = true;
    },
    cancelTextEditMode() {
      this.textResultList = JSON.parse(JSON.stringify(this.backupTextResultList));
      this.textEditMode = false;
    },
    handleTextEdit() {
      for (let i = 0; i < this.textResultList.length; ++i) {
        if (this.hasSpecialCharacterInString(this.textResultList[i].transcript)) {
          this.modalFlg = 'invalidCharactor';
          this.showErrorModal(messageContent.hasSpecialCharacter);
          return;
        }
      }
      const formData = {
        textResultList: this.textResultList,
        recordingUrl: this.recordingUrl,
        companyID: this.selectedCompanyID,
      };
      // Spannerの音声テキスト化結果をアップデートしている
      this.postRequest('/voicetotext/updateTexts', formData).then(res => {
        this.backupTextResultList = JSON.parse(JSON.stringify(this.textResultList));
        this.textEditMode = false;
      });
    },
    doDeleteText(index) {
      // HTML上のテキストを削除している、Spannerに保存はしていない
      this.textResultList.splice(index, 1);
    },
    getFlags() {
      const formData = {
        callSid: this.CallSid,
        companyId: this.selectedCompanyID,
      };
      // 留守録があるか確認している
      this.postRequest('/voicetotext/getFlags', formData).then(res => {
        this.voicemessageFlag = res.result[0].voicemessageFlag;
      });
    },
  },
};
</script>
